import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'domSanitizer'
})
export class DomsanitizerPipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer){ }

  transform(value: string, type: string): SafeHtml | SafeResourceUrl {
    switch (type) {
      case 'html':
        // Se utiliza para que los style de los html carguen ok (campos que vengan del editor enriquecido CRM)
        return this._sanitizer.bypassSecurityTrustHtml(value);
      case 'url':
        // Se utiliza para poder mostrar contenido de videos (youtube)
        return this._sanitizer.bypassSecurityTrustResourceUrl(value);
      default:
        return value;
    }
  }
}
